// src/components/common/TableSkeleton.jsx
import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Skeleton,
} from '@mui/material';

const TableSkeleton = ({ rows = 10, columns = 6 }) => {
    return (
        <TableContainer>
            <Table size="small">
                <TableBody>
                    {Array.from(new Array(rows)).map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {Array.from(new Array(columns)).map((_, colIndex) => (
                                <TableCell key={colIndex}>
                                    <Skeleton variant="text" animation="wave" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableSkeleton;
